import Vue from 'vue'
import VueResource from 'vue-resource'
import RingLoader from 'vue-spinner/src/RingLoader.vue'
import mixins from '../mixins.js'
import datePicker from '../../component/datePicker.vue'
import moment from 'moment'
import 'moment/locale/pl'
import TextInput from '../../component/dccore-form/textInput.vue'
import Singleselect from '../../component/simple-form/singleselect.vue'

if ($('#user_history_form').length) {
  Vue.use(VueResource)
  new Vue({
    el: '#user_history_form',
    components: {
      RingLoader,
      datePicker,
      TextInput,
      Singleselect
    },
    mixins: [mixins],
    data: {
      loading: 0,
      searchForm: {
        dateFrom: moment().subtract(60, 'days').locale('pl').format('YYYY-MM-DD'),
        dateTo: moment().locale('pl').format('YYYY-MM-DD'),
        userType: null,
        brand: null,
        email: null,
      },
      brands: [],
      loadingBrands: false,
      formHash: null,
      users: [],
    },
    computed: {
      user: function () {
        return this.searchForm.user
      },
      isCorrectDateRange() {
        return moment(this.searchForm.dateTo).diff(moment(this.searchForm.dateFrom), 'days') <= 60
      }
    },
    mounted: function () {
      this.loading++
      this.getBrands()
      if ($('#form_hash').length) {
        this.formHash = $('#form_hash').val()
      }

      this.loading--
    },
    created: function () {
      this.USER_TYPES = [
        {
          id: 'CLIENT',
          name: 'Klient'
        },
        {
          id: 'EMPLOYEE',
          name: 'Pracownik'
        }
      ]
    },
    methods: {
      getBrands() {
        let url = Routing.generate('api_get_brands', {context: 'dropdown'})
        this.loadingBrands = true
        this.$http.get(url).then(response => {
          this.brands = response.data
          this.loadingBrands = false
        }, response => {
          this.handleAjaxError(response)
          this.loadingBrands = false
        })
      },
      search() {
        $('.grid-filter-input-query-from[name=date_from]').val(this.searchForm.dateFrom)
        $('.grid-filter-input-query-from[name=date_to]').val(this.searchForm.dateTo)
        $('.grid-filter-input-query-from[name=email]').val(this.searchForm.email)
        $('.grid-filter-input-query-from[name=brand]').val(this.searchForm.brand)
        $('.grid-filter-input-query-from[name=userType]').val(this.searchForm.userType)
        window[`${this.formHash}_submitForm`](new Event(''))
      },
    },

  })
}
